import Vue from 'vue'
import Vuex from 'vuex'
import snackbar from '@/store/modules/snackbar'
import loading from '@/store/modules/loading'
import auth from '@/store/modules/auth'
import user from '@/store/modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    snackbar,
    loading,
    auth,
    user
  },
  strict: debug
})
